export const SETTINGS_EVENTS = {
  rowPressed: 'settings_row_pressed',
  languageChanged: 'settings_language_changed',
  languageAutoDetected: 'settings_language_auto_detected',
  themeChanged: 'settings_theme_changed',
  dialogActionPressed: 'settings_dialog_action_pressed',
} as const;

export type SettingsEventNameType = (typeof SETTINGS_EVENTS)[keyof typeof SETTINGS_EVENTS];
